import React from 'react'
import { Field, FieldArray, FieldProps } from 'formik'
import { useServiceContext } from '../../../../../root'
import { WF_STEP_TYPE } from './constants'
import UserGroupSteps from './UserGroupSteps'

interface EditStepFormProps {
  values: any
  setFieldValue: (field: string, value: any) => void
}

const EditStepForm: React.FC<EditStepFormProps> = ({ values, setFieldValue }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const collaboratorsType = values.collaborators?.type || WF_STEP_TYPE.USE_INITIATOR

  return (
    <>
      <div className="form-group">
        <label className="control-label">{translate('BROWSER_FILE_SETTINGS_EDITORS_TYPE_HEADLINE')}</label>
        <Field name="collaborators.type">
          {({ field }: FieldProps) => (
            <>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`311be098-0326-4f8c-bb27-dafc630f791d-${WF_STEP_TYPE.USE_INITIATOR}`}
                    value={WF_STEP_TYPE.USE_INITIATOR}
                    checked={collaboratorsType === WF_STEP_TYPE.USE_INITIATOR}
                    onChange={() => setFieldValue('collaborators.type', WF_STEP_TYPE.USE_INITIATOR)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_EDITORS_LABEL_USE_CURRENT')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`311be098-0326-4f8c-bb27-dafc630f791d-${WF_STEP_TYPE.SETUP_WITH_WORKFLOW}`}
                    value={WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    checked={collaboratorsType === WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    onChange={() => setFieldValue('collaborators.type', WF_STEP_TYPE.SETUP_WITH_WORKFLOW)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_EDITORS_LABEL_SETUP_EDITORS_WITH_CR')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`311be098-0326-4f8c-bb27-dafc630f791d-${WF_STEP_TYPE.USE_PREDEFINED}`}
                    value={WF_STEP_TYPE.USE_PREDEFINED}
                    checked={collaboratorsType === WF_STEP_TYPE.USE_PREDEFINED}
                    onChange={() => setFieldValue('collaborators.type', WF_STEP_TYPE.USE_PREDEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_EDITORS_LABEL_USE_PREDEFINED')}
                </label>
              </div>
            </>
          )}
        </Field>
      </div>
      {/* Show UserGroupSteps when USE_PREDEFINED is selected */}
      {collaboratorsType === WF_STEP_TYPE.USE_PREDEFINED && (
        <UserGroupSteps
          name="collaborators.steps"
          values={values.collaborators?.steps || []}
          labelTxt={'BROWSER_FILE_SETTINGS_EDITORS_SEQUENCE_HEADLINE'}
          nofallTxt={'BROWSER_FILE_SETTINGS_EDITORS_INFO_LABEL'}
        />
      )}
      {/* Show error if no steps defined in Edit phase */}
      {collaboratorsType === WF_STEP_TYPE.USE_PREDEFINED &&
        (!values.collaborators?.steps || !values.collaborators.steps.length) && (
          <div className="error-message text-danger mb-3">
            {translate('BROWSER_FILE_SETTINGS_EDITORS_STEPS_REQUIRED')}
          </div>
        )}
    </>
  )
}

export default EditStepForm
